import React from 'react';
import { useMediaQuery } from 'react-responsive';

import { request } from '../../../api';

const VtrgCenteredImage = ({ data, slot }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  const updatedTime = data && data.updated_at ? new Date(data.updated_at).getTime() : 0;
  const img = `${request}${data?.image?.url && data.image.url}?v=${updatedTime}`;
  const imgstyle = {};
  
  if (data && data.max_width) {
    imgstyle.maxWidth = `${data.max_width}%`;
  }
  const blstyle = {
    backgroundColor: data.back_color,
    backgroundRepeat: data.back_repeat ? 'repeat' : 'no-repeat',
    paddingTop: `${data.pad_top ? isMobile ? data.pad_top / 2 : data.pad_top : 0}px`,
    paddingRight: `${data.pad_rgh ? isMobile ? data.pad_rgh / 2 : data.pad_rgh : 0}px`,
    paddingBottom: `${data.pad_bot ? isMobile ? data.pad_bot / 2 : data.pad_bot : 0}px`,
    paddingLeft: `${data.pad_lft ? isMobile ? data.pad_lft / 2 : data.pad_lft : 0}px`,
  };
  if (data && data.backmage && data.backmage.url) {
    blstyle.backgroundImage = `url("${data.backmage.url}")`;
  }

  return (
    <div className="cb-centered-image" style={blstyle} data-slot={slot}>
      <img src={img} style={imgstyle} />
    </div>
  );
};

export default VtrgCenteredImage;
